module.exports = "/images/x_twitter.svg?50660456d7f789053d9c3088c3ffe369";